import { Dialog, DialogTitle, DialogContent, List, ListItemButton, ListItemText, DialogActions, Button, Typography } from '@mui/material';
import { ModuleKey, widgetsFor } from '../registry';

interface Props {
    open: boolean;
    hasPermission: (key: string) => boolean;
    present: string[];
    enabledModules: ModuleKey[];
    onAdd: (id: string) => void;
    onClose: () => void;
}

export default function AddWidgetDialog({ open, hasPermission, present, enabledModules, onAdd, onClose }: Props) {
    const available = widgetsFor(hasPermission, enabledModules).filter(w => !present.includes(w.id));
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="xs">
            <DialogTitle>Add a widget</DialogTitle>
            <DialogContent dividers data-help-section="dashboard.addDialog">
                {available.length === 0
                    ? <Typography variant="body2" color="text.secondary">Every widget available to you is already on the board.</Typography>
                    : (
                        <List>
                            {available.map(w => (
                                <ListItemButton key={w.id} onClick={() => { onAdd(w.id); onClose(); }}>
                                    <ListItemText primary={w.title} secondary={w.module} />
                                </ListItemButton>
                            ))}
                        </List>
                    )}
            </DialogContent>
            <DialogActions><Button onClick={onClose}>Close</Button></DialogActions>
        </Dialog>
    );
}
